import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { genfunction } from 'helpers'
import CancelIcon from '@material-ui/icons/Cancel'
import {
    Card, CardContent, CardHeader, Grid, IconButton,
    Table, TableBody, TableCell, TableRow,
} from '@material-ui/core';

import { actionDeleteGiftCardHold } from 'actions';
import { actionGetTransactionFee } from 'actions';

const { TransactionFeeProductID, ApplyTransactionFee, Currency } = window['runConfig'];

const useStyles = makeStyles(theme => ({

    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        height: '40px',
    },
    labelbold: {
        fontWeight: "bold",
        fontSize: "18px",

    },
    textaligncenter: {
        textAlign: "center"
    },

    cashlessvalue: {
        color: theme.palette.error.main
    },
    couponAmount: {
        color: 'red'
    }
}));

const PayableCardMMB = props => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const transactionfee = useSelector(state => state.reducerTransactionFee);
    const showTransFee = useSelector(state => state.reducerShopCart.showTransactionFee);
    let enteredAmountToPay = useSelector(state => state.reducerShopCart.enteredAmountToPay);
    let shopcartamounttoPay = useSelector(state => state.reducerShopCart.mmbAmountToPay);
    let refundType = useSelector(state => state.reducerShopCart.refundType);
    const cashless = useSelector(state => state.reducerShopCart.cashless);
    let cashlesstotal = cashless.map(({ HoldAmount }) => HoldAmount).reduce((sum, i) => sum + i, 0);
    const events = useSelector(state => state.reducerShopCart.events);
    const booking = useSelector(state => state.reducerBooking).booking[0];

    let bookingName = booking.BookingName.split("Event:")[1] ? booking.BookingName.split("Event:")[1] : booking.BookingName;


    const removecashlesskhandler = (GiftcardHoldRef) => {
        actionDeleteGiftCardHold(dispatch, GiftcardHoldRef);
    }

    useEffect(() => {

        if (ApplyTransactionFee && TransactionFeeProductID > 0) {
            actionGetTransactionFee(dispatch, TransactionFeeProductID, 'transactionfee');
        }
    }, [])


    return (
        <Grid container justify="center"  >
            <Grid item xs={12} md={7} >
                <Card>
                    <CardHeader className={classes.tourheaderbox + ' ' + classes.textaligncenter}
                        title="To Pay"
                        titleTypographyProps={{ color: "inherit", variant: 'h3' }}
                    />
                    <CardContent>
                        <Grid container>
                            <Grid container item xs={12} >
                                <Table size="small" className={classes.table} aria-label="spanning table">
                                    <TableBody>

                                        <TableRow key={booking.TourEventID} >
                                            <TableCell>{bookingName}</TableCell>
                                            <TableCell align="right">{genfunction.ccyFormat(enteredAmountToPay)}</TableCell>
                                        </TableRow>

                                        {showTransFee && transactionfee.transactionFee[0] && transactionfee.transactionFee[0].Price > 0 && transactionfee.transactionFee !== "nocontent" ?
                                            <TableRow key={transactionfee.transactionFee[0].Price}>

                                                <TableCell className={classes.tablecell} align="left">
                                                    {transactionfee.transactionFee[0].ProductName}
                                                </TableCell>
                                                <TableCell align="right">

                                                    {(refundType === "AdditionalPayment" || (refundType === "" && shopcartamounttoPay > 0)) ?
                                                        genfunction.ccyFormat(parseFloat(genfunction.TransactionFeeForPartialPayment(transactionfee.transactionFee[0], enteredAmountToPay, cashlesstotal))) :
                                                        genfunction.ccyFormat(parseFloat(genfunction.TransactionFee(events, null, transactionfee.transactionFee[0], cashless, null, null, null, null, null)))}

                                                </TableCell>
                                            </TableRow> : null}

                                        {cashless.map(objcashless => (
                                            <TableRow key={objcashless.GiftcardNo}>
                                                <TableCell>
                                                    <IconButton
                                                        edge="start"
                                                        size="small"
                                                        onClick={() => removecashlesskhandler(objcashless.GiftcardHoldRef)}
                                                    >
                                                        <CancelIcon color={"error"} />
                                                    </IconButton>
                                                    {'Giftcard Applied - ' + genfunction.maskGiftCardNo(objcashless.GiftcardNo)}</TableCell>
                                                <TableCell align="right" className={classes.cashlessvalue}>{'-' + genfunction.ccyFormat(objcashless.HoldAmount)}</TableCell>
                                            </TableRow>
                                        ))}
                                        <TableRow>
                                            <TableCell className={classes.labelbold}>Amount To Pay</TableCell>
                                            <TableCell className={classes.labelbold} align="right">{Currency}{props.AmountToPay}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>

        </Grid>
    );
};

PayableCardMMB.propTypes = {
    products: PropTypes.array.isRequired
};

export default PayableCardMMB;
